import React from "react";
import TableWrapper from "../elements/TableWrapper";
import { Layout, message, Row, Col, Modal, Select } from "antd";
import img from "../../assets/img/At the office-pana 1.png";
import MiCompAPI from "../../util/api";
import AddEvent from "./AddEvent";

const { Content } = Layout;
const { confirm } = Modal;

class ManageEvent extends React.Component {
  constructor(props) {
    super(props);
    this.columnsdata = [
      {
        title: "Event Name",
        dataIndex: "eventName",
        sorter: (a, b) => a.eventName.localeCompare(b.eventName),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Module Name",
        dataIndex: "moduleName",
        sorter: (a, b) => a.moduleName.localeCompare(b.moduleName),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Event Type",
        dataIndex: "eventTypeName",
        sorter: (a, b) => a.eventTypeName.localeCompare(b.eventTypeName),
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Description",
        dataIndex: "eventDescription",
        sorter: (a, b) => a.eventDescription.localeCompare(b.eventDescription),
        sortDirections: ["descend", "ascend"],
      },
      // {
      //   title: "Template Id",
      //   dataIndex: "templateId",
      //   sorter: (a, b) => a.templateId.localeCompare(b.templateId),
      //   sortDirections: ["descend", "ascend"],
      // },
      {
        title: "Action",

        render: (text, record) => {
          return (
            <div style={{ display: "flex", width: 20 }}>
              <>
                <i
                  onClick={() => {
                    this.EditEvent(record.eventId);
                  }}
                  className="fa fa-pencil fa-b"
                  aria-hidden="true"
                  hidden={record.is_PredefinedEvent?true:false}
                ></i>
                <i
                  style={{ marginLeft: 10 }}
                  onClick={() => this.DeleteEvent(record["eventId"])}
                  className="fa fa-trash fa-red "
                  aria-hidden="true"
                  hidden={record.is_PredefinedEvent?true:false}
                ></i>
              </>
            </div>
          );
        },
      },
    ];
    this.state = {
      allEvents: true,
      data: [],
      addEvent: false,
      isLoading: this.props.isLoading,
      eEvent: null,
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    this.GetAllEvents();
  }

  // EditEvent = (val) => {
  //   this.setState({
  //     addEvent: true,
  //     eEvent: val,
  //   });
  // };

  EditEvent = (val) => {
    this.api.invoke("GetEventById/"+val, "get", (data, status) => {
        if (status) {
            if (data.statusCode === 200) {
               
                this.setState({
                  addEvent:true,
                  eEvent:data.data
                })           
            } else {
                message.destroy();
                message.error(data.statusMessage, 3);
            }
        }
    });
    
};



  GetAllEvents() {
    this.api.invoke("GetAllEvents", "get", (data, status) => {
      if (status) {
        if (data.statusCode === 200) {
          const field = data.data;
          this.data = field;
          this.setState({ allEvents: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }

  DeleteEvent = (id) => {
    confirm({
      title: "Do you want to delete this Event?",
      onOk: () => {
        this.api.invoke("DeleteEvent/" + id, "patch", (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
              this.setState({ isLoading: false });
              this.GetAllEvents();
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        });
      },
      okText: "Yes",
      cancelText: "No",
      onCancel() {},
    });
  };

  InsertAndUpdateEvent = (data, callback) => {
    this.api.invoke(
      "InsertAndUpdateEvent",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {                
            this.GetAllEvents();
            message.destroy();
            message.success(data.statusMessage, 3);
            this.UserDefaultHandler();
            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        } else {
        }
      },
      data
    );
  };

  UserDefaultHandler = () => {
    this.setState({ addEvent: false, eEvent: null });
  };

  render() {
    this.tableButtons = [
      {
        buttonType: "primary",
        content: "New Event",
        clickHandler: () => {
          this.setState({ addEvent: true });
        },
      },
    ];
    return (
      <Content>
        {this.state.addEvent ? (
          <Modal visible={this.state.addEvent}>
            <AddEvent
              userPermandMasters={this.props.userPermandMasters}
              closeDrawerHandler={this.UserDefaultHandler}
              submitHandler={this.InsertAndUpdateEvent}
              width="500"
              eEvent={this.state.eEvent}
            />
          </Modal>
        ) : null}
          <div className="mi_main_div" >
          <Row span={24} style={{marginLeft:"10px",marginRight:"12px"}}>
            <Col span={24}>

          <TableWrapper
            rowKey="eventId"
            columns={this.columnsdata}
            data={this.state.allEvents ? null : this.data}
            loading={this.state.allEvents}
            buttons={this.tableButtons}
            title="Manage Events"
            search={true}
          />
        </Col>
          </Row>
        </div>
      </Content>
    );
  }
}
export default ManageEvent;
